import science_icon from './images/science_icon.svg';
import physics_icon from './images/physics_icon.svg';
import italian_icon from './images/italian_icon.svg';
import art_history_icon from './images/art_history_icon.svg';
import civic_education_icon from './images/civic_education_icon.svg';
import english_icon from './images/english_icon.svg';
import history_icon from './images/history_icon.svg';
import math_icon from './images/math_icon.svg';
import pe_icon from './images/pe_icon.svg';
import phylosophy_icon from './images/phylosophy_icon.svg';
import religion_icon from './images/religion_icon.svg';
import technical_drawing_icon from './images/technical_drawing_icon.svg';
import music_icon from './images/music_icon.svg';
import french_icon from './images/french_icon.svg';
import spanish_icon from './images/spanish_icon.svg';
import chinese_icon from './images/chinese_icon.svg';
import question_mark_icon from './images/question_mark_icon.svg';
import logo_icon from './images/logo_icon.svg';
import cartoon_avatar_icon from './images/cartoon_avatar_icon.svg';
import arrow_down_icon from './images/arrow_down_icon.svg';
import calendar_icon from './images/calendar_icon.svg';
import calendar_orange_icon from './images/calendar_orange_icon.svg';
import interrogation_icon from './images/interrogation_icon.svg';
import homework_icon from './images/home_icon.svg';
import test_icon from './images/test_icon.svg';
import test_white_icon from './images/test_white_icon.svg';
import edit_icon from './images/edit_icon.svg';
import edit_white_icon from './images/edit_white_icon.svg';
import add_icon from './images/add_icon.svg';
import add_orange_icon from './images/add_orange_icon.svg';
import user_icon from './images/user.svg';
import lock_icon from './images/lock.svg';
import email_icon from './images/mail.svg';
import email_orange_icon from './images/mail_orange_icon.svg';
import school_icon from './images/school_icon.svg';
import trash_icon from './images/trash.svg';
import trash_white_icon from './images/trash_white_icon.svg';
import computer_science_icon from './images/computer_science_icon.svg';
import disconnected_icon from './images/disconnected_icon.svg';
import warning_icon from './images/danger.svg';
import settings_icon from './images/settings_icon.svg';
import apple_icon from './images/apple_icon.svg';
import loading_icon from './images/loading_icon.svg';
import logout_icon from './images/logout_icon.svg';
import logout_white_icon from './images/logout_white_icon.svg';
import lock_white_icon from './images/lock_white_icon.svg';
import iOS_share_icon from './images/iOS_share_icon.svg';
import latin_icon from './images/latin_icon.svg';
import law_icon from './images/law_icon.svg';
import geography_icon from './images/geography_icon.svg';
import home_icon from './images/home_icon.svg';
import mail_icon from './images/mail.svg';
import gmail_icon from './images/gmail_icon.svg';
import instagram_icon from './images/instagram_icon.svg';
import instagram_orange_icon from './images/instagram_orange_icon.svg';
import discord_icon from './images/discord_icon.svg';
import discord_orange_icon from './images/discord_orange_icon.svg';
import arrow_right_icon from './images/arrow_right_icon.svg';
import notification_icon from './images/notification_icon.svg';
import accounting_icon from './images/accounting_icon.svg';
import german_icon from './images/german_icon.svg';
import slovenian_icon from './images/slovenian_icon.svg';
import economy_icon from './images/economy_icon.svg';
import check_icon from './images/check_icon.svg';
import check_icon_disabled from './images/check_icon_disabled.svg';
import double_arrow_left from './images/double_arrow_left.svg';
import login_icon from './images/login_icon.svg';
import users_icon from './images/users_icon.svg';
import homework_disabled_icon from './images/homework_disabled_icon.svg';
import test_disabled_icon from './images/test_disabled_icon.svg';
import interrogation_disabled_icon from './images/interrogation_disabled_icon.svg';
import classroom_icon from './images/classroom_icon.svg';
import home_orange_icon from './images/home_orange_icon.svg';
import clock_icon from './images/clock_icon.svg';
import clock_orange_icon from './images/clock_orange_icon.svg';
import question_mark_orange_icon from './images/question_mark_orange_icon.svg';
import question_mark_orange_disabled_icon from './images/question_mark_orange_disabled_icon.svg';
import loop_orange_icon from './images/loop_orange_icon.svg';
import camera_icon from './images/camera_icon.svg';
import mic_icon from './images/ic_mic.svg';
import sound_wave_icon from './images/sound_wave_icon.svg';
import stop_icon from './images/stop_icon.svg';
import arrow_left_icon from './images/arrow_left_icon.svg';
import send_icon from './images/send_icon.svg';
import classroom_orange_icon from './images/classroom_orange_icon.svg';
import sync_icon from './images/sync_icon.svg';
import user_white_icon from './images/user_white_icon.svg';
import grade_icon from './images/grade_icon.svg';
import grade_orange_icon from './images/grade_orange_icon.svg';
import subjects_icon from './images/subjects_icon.svg';
import premium_icon from './images/premium_icon.svg';
import donation_icon from './images/donation_icon.svg';
import google_icon from './images/google_icon.svg';
import send_white_icon from './images/send_white_icon.svg';
import copy_to_clipboard_icon from './images/copy_to_clipboard_icon.svg';
import attachment_icon from './images/attachment_icon.svg';
import pdf_icon from './images/pdf_icon.svg';
import word_icon from './images/word_icon.svg';
import txt_icon from './images/text_icon.svg';
import download_icon from './images/download_icon.svg';
import google_play_store_icon from './images/google_play_store_icon.svg';
import calculations_icon from './images/calcualtions_icon.svg';
import chart_icon from './images/chart_icon.svg';
import map_geography_icon from './images/map_geography_icon.svg';
import design_planning_icon from './images/design_planning_icon.svg';
import telecommunication_icon from './images/telecommunication_icon.svg';
import network_icon from './images/network_icon.svg';
import art_icon from './images/art_icon.svg';
import info_icon from './images/info_icon.svg';
import timeline_icon from './images/timeline_icon.svg';
import search_white_icon from './images/search_white_icon.svg';
import visibility_white_icon from './images/visibility_white_icon.svg';
import visibility_off_white_icon from './images/visibility_off_white_icon.svg';
import visibility_icon from './images/visibility_icon.svg';
import visibility_off_icon from './images/visibility_off_icon.svg';
import invite_orange_icon from './images/invite_orange_icon.svg';
import leaderboard_icon from './images/leaderboard_icon.svg';
import leaderboard_empty_icon from './images/leaderboard_empty_icon.svg';
import announcement_icon from './images/announcement_icon.svg';
import announcement_white_icon from './images/announcement_white_icon.svg';
import more_icon from './images/more_icon.svg';
import globe_icon from './images/globe_icon.svg';
import ancient_greek_icon from './images/ancient_greek_icon.svg';
import greek_icon from './images/greek_icon.svg';
import sea_icon from './images/sea_icon.svg';
import ship_icon from './images/ship_icon.svg';
import carpenter_icon from './images/carpenter_icon.svg';
import photo_icon from './images/photo_icon.svg';
import excel_icon from './images/excel_icon.svg';
import ic_mic_disabled from './images/ic_mic_disabled.svg';
import cookies_icon from './images/cookies_icon.svg';
import arrow_up_icon from './images/arrow_up_icon.svg';
import study_icon from './images/study_icon.svg';
import study_orange_icon from './images/study_orange_icon.svg';
import drag_orange_icon from './images/drag_orange_icon.svg';
import flashcards_icon from './images/flashcards_icon.svg';
import box_white_icon from './images/box_white_icon.svg';
import cross_icon from './images/cross_icon.svg';
import question_mark_white_icon from './images/question_mark_white_icon.svg';
import classeviva_icon from './images/classeviva_icon.png';


const icons = {

    calculations_icon,
    chart_icon,
    map_geography_icon,
    design_planning_icon,
    telecommunication_icon,
    network_icon,
    art_icon,
    arrow_up_icon,
    arrow_down_icon,
    cartoon_avatar_icon,
    science_icon,
    phylosophy_icon,
    physics_icon,
    italian_icon,
    art_history_icon,
    civic_education_icon,
    english_icon,
    history_icon,
    math_icon,
    pe_icon,
    religion_icon,
    technical_drawing_icon,
    question_mark_icon,
    logo_icon,
    calendar_icon,
    homework_icon,
    interrogation_icon,
    test_icon,
    test_white_icon,
    edit_icon,
    edit_white_icon,
    add_icon,
    add_orange_icon,
    user_icon,
    lock_icon,
    email_icon,
    email_orange_icon,
    school_icon,
    trash_icon,
    trash_white_icon,
    computer_science_icon,
    disconnected_icon,
    warning_icon,
    settings_icon,
    apple_icon,
    loading_icon,
    logout_icon,
    lock_white_icon,
    iOS_share_icon,
    latin_icon,
    law_icon,
    geography_icon,
    home_icon,
    mail_icon,
    gmail_icon,
    instagram_icon,
    instagram_orange_icon,
    discord_icon,
    accounting_icon,
    german_icon,
    slovenian_icon,
    music_icon,
    french_icon,
    chinese_icon,
    spanish_icon,
    economy_icon,
    arrow_right_icon,
    notification_icon,
    check_icon,
    double_arrow_left,
    login_icon,
    users_icon,
    homework_disabled_icon,
    interrogation_disabled_icon,
    test_disabled_icon,
    classroom_icon,
    home_orange_icon,
    clock_icon,
    clock_orange_icon,
    question_mark_orange_icon,
    question_mark_orange_disabled_icon,
    loop_orange_icon,
    camera_icon,
    mic_icon,
    sound_wave_icon,
    stop_icon,
    arrow_left_icon,
    send_icon,
    classroom_orange_icon,
    sync_icon,
    user_white_icon,
    grade_icon,
    grade_orange_icon,
    subjects_icon,
    calendar_orange_icon,
    donation_icon,
    premium_icon,
    google_icon,
    send_white_icon,
    copy_to_clipboard_icon,
    logout_white_icon,
    attachment_icon,
    pdf_icon,
    word_icon,
    txt_icon,
    download_icon,
    check_icon_disabled,
    google_play_store_icon,
    discord_orange_icon,
    info_icon,
    timeline_icon,
    search_white_icon,
    visibility_white_icon,
    visibility_off_white_icon,
    visibility_icon,
    visibility_off_icon,
    invite_orange_icon,
    leaderboard_icon,
    leaderboard_empty_icon,
    announcement_icon,
    announcement_white_icon,
    more_icon,
    globe_icon,
    ancient_greek_icon,
    greek_icon,
    sea_icon,
    ship_icon,
    carpenter_icon,
    photo_icon,
    excel_icon,
    ic_mic_disabled,
    cookies_icon,
    study_icon,
    study_orange_icon,
    drag_orange_icon,
    flashcards_icon,
    box_white_icon,
    cross_icon,
    question_mark_white_icon,
    classeviva_icon,

    subjects_icons: {
    
        science_icon,
        phylosophy_icon,
        physics_icon,
        italian_icon,
        art_history_icon,
        civic_education_icon,
        english_icon,
        history_icon,
        math_icon,
        pe_icon,
        religion_icon,
        technical_drawing_icon,
        computer_science_icon,
        latin_icon,
        law_icon,
        geography_icon,
        accounting_icon,
        german_icon,
        slovenian_icon,
        french_icon,
        chinese_icon,
        spanish_icon,
        economy_icon,
        music_icon,
        calculations_icon,
        chart_icon,
        map_geography_icon,
        design_planning_icon,
        network_icon,
        art_icon,
        ancient_greek_icon,
        greek_icon,
        sea_icon,
        ship_icon,
        carpenter_icon,
    
    },

    subjects_colors: {

    },

    subjects_icons_by_name: {
        "science_icon": [ "scienze", "biologia" ],
        "phylosophy_icon": [ "filosofia" ],
        "physics_icon": [ "fisica" ],
        "italian_icon": [ "italiano" ],
        "art_history_icon": [ "storia dell'arte", "greco" ],
        "civic_education_icon": [ "educazione civica" ],
        "english_icon": [ "inglese" ],
        "history_icon": [ "storia" ],
        "math_icon": [ "matematica" ],
        "pe_icon": [ "ginnastica" ],
        "religion_icon": [ "religione" ],
        "technical_drawing_icon": [ "disegno" ],
        "computer_science_icon": [ "informatica" ],
        "latin_icon": [ "latino" ],
        "law_icon": [ "legge", "diritto" ],
        "geography_icon": [ "geografia" ],
        "map_geography_icon": [ "geografia" ],
        "accounting_icon": [ "ragioneria" ],
        "german_icon": [ "tedesco" ],
        "slovenian_icon": [ "sloveno" ],
        "french_icon": [ "francese" ],
        "chinese_icon": [ "cinese" ],
        "spanish_icon": [ "spagnolo" ],
        "economy_icon": [ "economia" ],
        "chart_icon": [ "economia", "estimo" ],
        "music_icon": [ "musica" ],
        "calculations_icon": [ "estimo" ],
        "telecommunication_icon": [ "comunicazioni" ],
        "network_icon": [ "reti" ],
        "telecommunication_icon": [ "comunicazioni" ],
        "art_icon": [ "arte" ],
        "ancient_greek_icon": [ "arte", "greco" ],
        "greek_icon": [ "storia dell'arte", "greco" ],
        "ship_icon": [ "nave", "navigazione" ],
        "sea_icon": [ "nave", "navigazione", "oceano", "mare", "marino", "marina" ],
        "carpenter_icon": [ "legname", "falegnameria" ],
        
    },

};

export default icons;